import { useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import CryptoJS from 'crypto-js';

const SECRET_KEY = 'qwertyuiop1234567890asdfghjklzxcvbnm0987654321';

export default function PaymentPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [amount, setAmount] = useState(null);
  const [error, setError] = useState(null);
  const [status, setStatus] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const test = "1"; // ₹1

const encrypted = CryptoJS.AES.encrypt(test, SECRET_KEY).toString();
const testtoken = encodeURIComponent(encrypted);

console.log(testtoken);

  useEffect(() => {
    if (!token) return;

    try {
      const decodedToken = decodeURIComponent(token);
      const bytes = CryptoJS.AES.decrypt(decodedToken, SECRET_KEY);
      const decrypted = bytes.toString(CryptoJS.enc.Utf8);

      if (!decrypted || isNaN(Number(decrypted))) {
        throw new Error('Invalid token');
      }

      setAmount(decrypted);
    } catch (err) {
      setError('Invalid or tampered payment link.');
    }
  }, [token]);

  const handlePayment = async () => {
    try {
      setIsLoading(true);
      setStatus("Redirecting to payment gateway...");
      const response = await fetch('https://www.pay.quantech.pro/pay', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ amount: Number(amount) * 100 }) // ₹1 -> 100 paise
      });

      const contentType = response.headers.get('content-type');
      if (!response.ok) {
        const text = await response.text();
        throw new Error(text);
      }

      if (contentType.includes('application/json')) {
        const data = await response.json();
        window.location.href = data.redirectUrl; // Redirect to PhonePe
      } else {
        throw new Error('Unexpected response from server.');
      }
    } catch (err) {
      setStatus(err.message || 'Payment initiation failed');
      setIsLoading(false);
    }
  };

  return (
    <div className="payment-container">
      <div className="payment-card">
        <div className="card-header">
          <h1>Secure Payment</h1>
          <h2>For Website Development</h2>
        </div>
        
        <div className="card-content">
          {error ? (
            <div className="error-container">
              <p className="error">{error}</p>
            </div>
          ) : amount ? (
            <>
              <div className="amount-container">
                <p className="amount-label">Amount to pay</p>
                <p className="amount-value">₹{amount}</p>
              </div>
              
              <button 
                className={`pay-button ${isLoading ? 'loading' : ''}`} 
                onClick={handlePayment}
                disabled={isLoading}
              >
                {isLoading ? 'Processing...' : 'Pay Now'}
              </button>
              
              {status && <p className="status-message">{status}</p>}
            </>
          ) : (
            <div className="loading-container">
              <div className="spinner"></div>
              <p>Decrypting payment information...</p>
            </div>
          )}
        </div>
        
        <div className="card-footer">
          <p className="secure-notice">
            <span className="lock-icon">🔒</span> 
            All payments are secure and encrypted
          </p>
        </div>
      </div>

      <style>{`
        .payment-container {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 20px;
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        }
        
        .payment-card {
          background: #ffffff;
          border-radius: 20px;
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
          width: 100%;
          max-width: 460px;
          overflow: hidden;
        }
        
        .card-header {
          padding: 35px 30px;
          text-align: center;
          background: linear-gradient(135deg, #3a7bd5, #00d2ff);
          color: white;
        }
        
        .card-header h1 {
          margin: 0;
          font-size: 28px;
          font-weight: 600;
          letter-spacing: 0.5px;
        }
        
        .card-header h2 {
          margin: 8px 0 0;
          font-size: 18px;
          font-weight: 400;
          opacity: 0.9;
        }
        
        .card-content {
          padding: 40px 30px;
        }
        
        .amount-container {
          text-align: center;
          margin-bottom: 30px;
        }
        
        .amount-label {
          font-size: 16px;
          color: #666;
          margin-bottom: 8px;
        }
        
        .amount-value {
          font-size: 42px;
          font-weight: 700;
          color:black;
          margin: 0;
        }
        
        .pay-button {
          display: block;
          width: 100%;
          padding: 16px;
          background-color: #b9ff66;
          color: black;
          border: none;
          border-radius: 12px;
          font-size: 18px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          box-shadow: 0 4px 12px rgba(46, 125, 50, 0.3);
        }
        
        .pay-button:hover {
          background-color: #256429;
          box-shadow: 0 6px 16px rgba(46, 125, 50, 0.4);
          transform: translateY(-2px);
        }
        
        .pay-button:active {
          transform: translateY(1px);
          box-shadow: 0 2px 8px rgba(46, 125, 50, 0.4);
        }
        
        .pay-button.loading {
          background-color: #74B577;
          cursor: not-allowed;
        }
        
        .status-message {
          margin-top: 20px;
          text-align: center;
          color: #555;
          font-size: 15px;
        }
        
        .error-container {
          background-color: #FFF1F0;
          border-radius: 10px;
          padding: 20px;
          text-align: center;
        }
        
        .error {
          color: #D32F2F;
          font-weight: 500;
          margin: 0;
        }
        
        .loading-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 30px 0;
        }
        
        .spinner {
          width: 40px;
          height: 40px;
          border: 4px solid rgba(46, 125, 50, 0.1);
          border-radius: 50%;
          border-top-color: #2E7D32;
          animation: spin 1s linear infinite;
          margin-bottom: 20px;
        }
        
        @keyframes spin {
          to {
            transform: rotate(360deg);
          }
        }
        
        .card-footer {
          padding: 15px 30px;
          background-color: #f9f9f9;
          border-top: 1px solid #eee;
        }
        
        .secure-notice {
          text-align: center;
          color: #666;
          font-size: 14px;
          margin: 0;
        }
        
        .lock-icon {
          margin-right: 5px;
        }
      `}</style>
    </div>
  );
}